import React, { useState, useEffect } from 'react';
import { getConsentChoice, acceptAnalyticsConsent, declineAnalyticsConsent } from '../../../Databases/analytics_consent';
import './CookieDisclaimer.css';

function CookieDisclaimer() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(!getConsentChoice());
  }, []);

  const handleAccept = () => {
    acceptAnalyticsConsent();
    setShow(false);
  };

  const handleDecline = () => {
    declineAnalyticsConsent();
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div className="cookie-disclaimer">
      <div className="cookie-disclaimer-inner">
        <div className="cookie-disclaimer-text">
          <span>
          We'd like to use optional analytics cookies to see how visitors use this site. We only turn them
          on if you click Accept — you can decline and still use everything on the site. See our{' '}
            <a href="/privacy-policy">Privacy Policy</a> for details.
          </span>
        </div>
        <div className="cookie-disclaimer-action">
          <button className="btn accept-button" onClick={handleAccept}>
              Accept
          </button>
          <button className="decline-button" onClick={handleDecline}>
              Decline
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieDisclaimer;
